import { observer } from "mobx-react-lite";
import classNames from "classnames";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../models";
import { IUserProfile } from "../../../models/currentUser/UserProfile";
import { AgentNameSettings } from "./agentNameSettings";
import { AvatarSettings } from "./avatarSettings";
import { PasswordSettings } from "./passwordSettings";
import styles from "./profileSettings.css";
import { ChipTag } from "../../chip/presets/ChipTag/ChipTag";
import { ChipTagGroup } from "../../chip/presets/ChipTagGroup/ChipTagGroup";
import { AppPermission } from "@closerplatform/spinner-openapi";

interface Props {
  userProfile: IUserProfile;
}
/**
 * Container for various profile-related settings
 * AvatarSettings and AgentNameSettings could theoretically be used for managing
 * other users' accounts, hence the `userProfile` prop. Password change, as it is,
 * makes sense for current user only.
 */
export const ProfileSettings: React.SFC<Props> = observer(({ userProfile }) => {
  const { uiStore } = useStore();

  return (
    <>
      <AvatarSettings userProfile={userProfile} />
      <AgentNameSettings userProfile={userProfile} />
      <div className={styles["skills-container"]}>
        {userProfile.userTags.length || userProfile.userTagGroups.length ? (
          <>
            <div className={styles["tag-container"]}>
              {userProfile.userTags.map((tag) => (
                <ChipTag key={tag.id} name={tag.name} enabled={tag.enabled} />
              ))}
            </div>
            <div className={classNames(styles["tag-container"], styles["tag-group-container"])}>
              {userProfile.userTagGroups.map((tagGroup) => (
                <ChipTagGroup key={tagGroup.id} name={tagGroup.name} enabled={tagGroup.enabled} />
              ))}
            </div>
          </>
        ) : (
          intl.formatMessage("settings.advisers.noSkills")
        )}
      </div>
      {uiStore.canDisplayWithPermission(AppPermission.SettingsPasswordChange) && (
        <PasswordSettings />
      )}
    </>
  );
});
